export default {
    collectionId: 0,
    collectionName: "",
    collectionFixed: "",
    fillingMapping: [],
    configurator: {
        uid: "",
        items: [],
        selectedProductSetId: null,
        hasSelectedSet: false,
        packs: []
    },
    variantInfos: [],
    productSets: [],
    productTypes: [],
    productTypeTexts: [],
    images: [],
    variantImages: [],
    selectedSet: -1,
    loadingContent: false
};
